/**
 * How long the console waits for the platform to answer one request, in ms.
 *
 * Derived, not tuned. SOURCE: `service.WriteTimeout` (the http.Server's
 * `writeTimeout`, 60 s, control/internal/service/service.go). Go starts that
 * clock once it has read the request's headers, and after it no write to the
 * connection succeeds, so no complete answer can reach the console later than
 * 60 s after the request arrived. This console's clock starts earlier, when it
 * sends, and the extra 5 s is a margin for the network between. A test reads
 * service.go and fails if the two drift apart.
 *
 * What it does NOT mean: the server's timeout does not stop a handler. A slow
 * write can still commit after the console has stopped waiting. That is why a
 * timed-out write is said as NOT KNOWN (a write may have landed), never as
 * failed, and why the page reads the state again. Past the bound a "Saving…"
 * ends (S-1063).
 */
export const REQUEST_TIMEOUT_MS = 65_000;
